import { Avatar, Heading } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}
export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;
interface LabelStyledProps {
  isSubmitting: boolean;
}
export const LabelStyled = styled.label<LabelStyledProps>`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  padding-left: ${({ theme }) => theme.spacings[500]};
  padding-right: ${({ theme }) => theme.spacings[500]};
  padding-top: ${({ theme }) => theme.spacings[400]};
  padding-bottom: ${({ theme }) => theme.spacings[400]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
  ${(props) =>
    props.isSubmitting
      ? css`
          opacity: 0.4;
          pointer-events: none;
        `
      : css`
          cursor: pointer;
        `};
`;

export const SubHeaderStyled = styled(LabelStyled)`
  ${({ theme }) => css`
    padding-top: ${({ theme }) => theme.spacings[500]};
    padding-bottom: ${({ theme }) => theme.spacings[500]};
    background-color: ${theme.colors.grey[100]};
    justify-content: space-between;
  `}
`;
